import * as React from 'react'

export const Header = (props) => {
  return (
    <header className="header">
      <div className="wrapper flex-row">{props.children}</div>
    </header>
  )
}
